<template>
  <div class="card card-default d-flex flex-column col-12 shadow">
    <div class="card-body d-flex flex-column">
      <div
        class="d-flex"
        :class="{
          'mb-3': isVisible
        }"
      >
        <img
          v-if="configGroup.cBildPfad"
          class="config-group-image"
          :src="configGroup.cBildPfad[0] === '/' ? configGroup.cBildPfad : '/' + configGroup.cBildPfad"
          :alt="configGroup.cName">
        <div class="d-flex justify-content-between w-100">
          <div class="mr-5 ml-2 align-items-start d-flex flex-column">
            <h5>{{configGroup.cName}}</h5>
            <p v-html="configGroup.cBeschreibung"></p>
          </div>
          <span @click="isVisible = !isVisible" class="d-flex align-items-center">
            <i
              class="fa fa-2x fa-angle-up text-primary"
              :class="{'rotate': !isVisible}"
            ></i>
          </span>
        </div>
      </div>

      <template v-if="isVisible" :key="item">
        <template
            v-if="configGroup.nTyp === $filters.configTypes.CONFIG_GROUP_TYPE_CHECKBOX"
            v-for="item in configGroup.oItem_arr"
        >
          <ConfigGroupItem :config-group-item="item" config-type="checkbox" />
        </template>

        <template
            v-if="configGroup.nTyp === $filters.configTypes.CONFIG_GROUP_TYPE_RADIO"
            v-for="item in configGroup.oItem_arr"
        >
          <ConfigGroupItem :config-group-item="item" config-type="radio" />
        </template>


        <template v-if="
          configGroup.nTyp === $filters.configTypes.CONFIG_GROUP_TYPE_DROPDOWN
          || configGroup.nTyp === $filters.configTypes.CONFIG_GROUP_TYPE_DROPDOWN_MULTI"
        >

          <div class="col p-3" style="background-color: #F2F2F2" >
            <select class="col py-2"
              @change="handleChangeAction"
              v-model="selectedItem"
            >
              <option
                  v-for="item in configGroup.oItem_arr"
                  :value="getArticleConfigGroupItems(item).kKonfigitem"
                  v-html="`${getArticleConfigGroupItems(item).cName}  +${getArticleConfigGroupItems(item).fPreisLocalized[0]}`"
              ></option>
            </select>
              <div class="row mt-3" v-if="selectedItem && getArticleConfigGroupItems(selectedItem).fMax > 1">
                <div class="col-auto">
                  <span>Menge:</span>
                </div>
                <div class="col-auto">
                  <input
                      @change="selectedItemQuantity"
                      class="configuration-overview-cartMultiplier"
                      style="border-radius: 16px; border: 0; padding-left: 9px;"
                      type="number"
                      value="1"
                      min="1"
                      :max="getArticleConfigGroupItems(selectedItem).fMax"
                  />
                </div>
              </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>

import {computed, ref} from "vue";
import {useStore} from "vuex";
import ConfigGroupItem from "components/ConfigGroupItem";
import {onSelectableInputChanged} from "../composable/onSelectableInputChanged";

export function createConfigGroupElementId(id) {
  return `wnm_productConfigurator_configGroup_${id}`;
}

export default {
  name: "ConfigGroup",
  components: {ConfigGroupItem},
  props: {
    configGroup: {
      type: [String, Number],
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const configGroup = store.state.articleConfigGroups[props.configGroup];
    const selectedItem = computed(() => configGroup.oItem_arr.find((itemId) => store.state.currentConfiguration.configurationItems[itemId] >= 1));

    const defaultConfigItems = configGroup.oItem_arr.filter((itemId) => {
      const configItem = getArticleConfigGroupItems(itemId);
      return configItem && configItem.fPreis[0] === 0;
    });

    if(defaultConfigItems.length > 1) {
      throw new Error(`More then one default config item! ${defaultConfigItems.join(',')}`);
    } else if(!defaultConfigItems) {
      throw new Error('Invalid defaultConfigItems!');
    } else if(defaultConfigItems.length === 1) {
      onSelectableInputChanged(defaultConfigItems[0], configGroup);
    }

    if (!configGroup) {
      throw new Error(`Unknown config group ${props.configGroup}`);
    }

    //serverhero only unfold first element -> rest according to settings
    const isFirstGroup = store.state.sortOrders.articleConfigGroups.indexOf(props.configGroup) === 0;
    const isVisible = ref(isFirstGroup ? true : !store.state.options.foldConfigGroupsInitially);

    function getConfigGroupForConfigItem(id) {
      return store.getters.getConfigGroupForConfigItem(id);
    }

    function getArticleConfigGroupItems(id) {
      return store.state.articleConfigGroupItems[id];
    }

    return {
      isVisible,
      configGroup,
      selectedItem,

      createConfigGroupElementId,

      getArticleConfigGroupItems(id) {
        return store.state.articleConfigGroupItems[id];
      },

      handleChangeAction({target}) {
        const configGroupForItem = getConfigGroupForConfigItem(target.value);
        onSelectableInputChanged(target.value, configGroupForItem);
      },

      selectedItemQuantity (e) {
        store.dispatch('updateConfigurationItem', {
          id: selectedItem.value,
          quantity: e.target.value
        });
      },

    }
  }
}
</script>

<style scoped>
.config-group-image {
  max-height: 100px;
  max-width: 100px;
  align-self: center;
}

.rotate {
  transform: rotate(180deg);
}
</style>